<script setup lang="ts">
import DOMPurify, { Config } from 'dompurify';
import { computed, MaybeRefOrGetter, toValue } from 'vue';
import { merge } from 'lodash';

const props = defineProps<{
  value: MaybeRefOrGetter<string | undefined>;
  options?: Config;
}>();

const options = computed(() => {
  // ALLOWED_TAGS are overruled by USE_PROFILES so we don't set Profile when they are passed in.
  // See https://github.com/cure53/DOMPurify?tab=readme-ov-file#control-our-allow-lists-and-block-lists
  const defaults: Config = props.options?.ALLOWED_TAGS ? {} : { USE_PROFILES: { html: true } };

  return merge(defaults, props.options);
});

const dirtyHTML = computed(() => toValue(props.value) ?? '');

const sanitizedHTML = computed(() => {
  return DOMPurify.sanitize(dirtyHTML.value, options.value);
});
</script>

<template>
  <span v-html="sanitizedHTML" />
</template>
